<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" sm="12">
        <AppSectionHero :section-number="sectionNumber">
          <template v-slot:main-title>{{
            $t("content.sections.how.title.lead")
          }}</template>
          <template v-slot:title>{{
            $t("content.sections.how.title.body")
          }}</template>
        </AppSectionHero>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" lg="6">
        <p class="pt-3">{{ $t("content.sections.how.intro") }}</p>
        <AppDashboardSection>
          <template v-slot:intro>
            <h3>
              {{ $t("content.sections.how.subsections.paths.title") }}
            </h3>
            <div class="body-2">
              {{ $t("content.sections.how.subsections.paths.intro") }}
            </div>
          </template>
          <template v-slot:main>
            <SankeyResolutionPath />
          </template>
        </AppDashboardSection>
      </v-col>
      <v-col cols="12" lg="6">
        <AppDashboardSection>
          <template v-slot:intro>
            <h3>
              {{ $t("content.sections.how.subsections.helpfulness.title") }}
            </h3>
            <div class="body-2">
              {{ $t("content.sections.how.subsections.helpfulness.intro") }}
            </div>
          </template>
          <template v-slot:main>
            <ScatterHelpfulness />
          </template>
        </AppDashboardSection>
        <AppTableHidden
          :table-headers="tableHeaders"
          :table-data="tableData"
          sorted-column="peopleCount"
          :section-number="sectionNumber"
        >
          <template v-slot:table-title>
            {{ $t("content.sections.how.infoTable.title") }}
          </template>
          <template v-slot:card-info>
            <i18n tag="div" path="content.sections.how.infoTable.infoText">
            </i18n>
          </template>
        </AppTableHidden>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppBorderedSection from "@/components/AppBorderedSection.vue";
import AppSectionHero from "@/components/AppSectionHero.vue";
import AppDashboardSection from "@/components/AppDashboardSection.vue";
import SankeyResolutionPath from "@/components/SankeyResolutionPath.vue";
import ScatterHelpfulness from "@/components/ScatterHelpfulness.vue";
import AppTableHidden from "@/components/AppTableHidden.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    AppBorderedSection,
    AppSectionHero,
    AppDashboardSection,
    SankeyResolutionPath,
    ScatterHelpfulness,
    AppTableHidden
  },
  props: {
    sectionNumber: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      tableHeaders: [
        {
          text: this.$t("content.sections.how.infoTable.columnReason"),
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: this.$t(
            "content.sections.how.infoTable.columnRespondentsNumber"
          ),
          value: "peopleCount"
        },
        {
          text: this.$t(
            "content.sections.how.infoTable.columnRespondentsPercent"
          ),
          value: "peoplePercent"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["filteredCount", "filteredReasonNoActionData"]),
    tableData() {
      const data = [];
      this.filteredReasonNoActionData().forEach(d => {
        if (d.peopleCount != 0) {
          data.push({
            key: d.key,
            name: this.$t(`reasonsForNotAttempting.${d.key}`),
            peopleCount: d.peopleCount,
            peoplePercent: d.peoplePercent
          });
        }
      });
      return data;
    }
  }
};
</script>